


















import {Component, Vue, Watch} from "vue-property-decorator";

import {apiService} from '../services/api-service';
import {Category, Collection, OrderedItem} from "../model";
import KkImage from '@/components/KK-Image.vue';
import ItemCard from '@/components/ItemCard.vue';


@Component({
  components: {KkImage, ItemCard}
})
export default class CollectionView extends Vue {
  collection: Collection = new Collection({image: {}});
  items: OrderedItem[] = [];

  created() {
    this.load(parseInt(this.$route.params.id));
  }

  @Watch('$route') routeChanged(newRoute: any) {
    this.load(parseInt(newRoute.params.id));
  }

  async load(id: number) {
    this.collection = await apiService.loadCollection(id);
    this.items = await  apiService.loadCollectionItems(id);
  }
}
